import { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Button from '@mui/material/Button';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher.jsx';
import { tokens } from '../theme.js';

const LINKS = [
  { href: '#company', key: 'nav.company' },
  { href: '#solutions', key: 'nav.solutions' },
  { href: '#institutions', key: 'nav.institutions' },
  { href: '#approach', key: 'nav.approach' },
];

export default function Nav() {
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        bgcolor: 'rgba(251, 251, 249, 0.95)',
        backdropFilter: 'blur(8px)',
        borderBottom: `1px solid ${tokens.line}`,
      }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ gap: { xs: 1.5, md: 4 }, minHeight: { xs: 74, md: 86 } }}>
          <Link
            href="#top"
            underline="none"
            sx={{
              display: 'block',
              flexShrink: 0,
            }}
          >
            <Box
              component="img"
              src={`${process.env.PUBLIC_URL}/logo_removebg.png`}
              alt="Caurex"
              sx={{ width: { xs: 180, sm: 220 }, maxWidth: '100%', height: 'auto', display: 'block' }}
            />
          </Link>
          <Box
            component="nav"
            aria-label={t('nav.ariaLabel')}
            sx={{ display: { xs: 'none', md: 'flex' }, gap: 2.5, ml: 'auto' }}
          >
            {LINKS.map((link) => (
              <Link
                key={link.href}
                href={link.href}
                underline="none"
                sx={{ color: 'text.secondary', fontSize: '0.9rem', '&:hover': { color: 'primary.dark' } }}
              >
                {t(link.key)}
              </Link>
            ))}
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 2 }, ml: { xs: 'auto', md: 0 } }}>
            <LanguageSwitcher variant="light" />
            <Button variant="contained" size="small" href="#contact" sx={{ display: { xs: 'none', sm: 'inline-flex' } }}>
              {t('nav.contact')}
            </Button>
            <IconButton
              aria-label={t('nav.openMenu')}
              onClick={() => setMenuOpen(true)}
              sx={{ display: { xs: 'inline-flex', md: 'none' }, color: tokens.ink }}
            >
              <MenuIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </Container>
      <Drawer anchor="right" open={menuOpen} onClose={() => setMenuOpen(false)}>
        <Box sx={{ width: 280, pt: 2 }} role="navigation" aria-label={t('nav.mobileAriaLabel')}>
          <List>
            {[...LINKS, { href: '#contact', key: 'nav.contact' }].map((link) => (
              <ListItemButton key={link.href} component="a" href={link.href} onClick={() => setMenuOpen(false)}>
                <ListItemText primary={t(link.key)} />
              </ListItemButton>
            ))}
          </List>
        </Box>
      </Drawer>
    </AppBar>
  );
}
